exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#page-dashboard{display:-webkit-box;display:-ms-flexbox;display:flex}.dashboard-side-nav-wrapper{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:6rem;flex-basis:6rem;width:6rem;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.nav-expanded .dashboard-side-nav-wrapper{-ms-flex-preferred-size:220px;flex-basis:220px;width:220px}.dashboard-view{display:-webkit-box;display:-ms-flexbox;display:flex;height:100vh;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}", ""]);

// exports
